@if (hh30DayReviewPeriods) {
  <div class="service-line-dialog">
    <div class="p-form-widget p-form-view-data">
      <form [formGroup]="serviceLineEditForm">
        @if (!showHeaderForDateSelect && !hh30DayReviewPeriods) {
          <p-panel class="mb-8" [toggleable]="false" header="Instructions">
            <div class="edit-instructions-panel">{{ editInstructions }}</div>
          </p-panel>
        }
        <div class="flex flex-col p-form-widget p-form-view-data">
          <div class="field">
            <label class="font-interruption">Date/Time Request Received:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.dateTimeFaxRecieved | date :'MM/dd/yyyy hh:mm:ss a' }}</div>
            </div>
          </div>
          @if (requestType === initialRequestType) {
            <div>
              <div class="field">
                <label class="font-interruption">Urgency: </label>
                <div class="p-field-value">
                  <div class="readonly-field">{{ editDetail.urgency }}</div>
                </div>
              </div>
            </div>
          }
          @if (requestType === subsequentRequestType) {
            <div class="col p-0">
              <div class="field">
                <label class="font-interruption">Urgency:</label>
                <div class="p-field-value pl-4">
                  <p-select
                    [options]="urgencies"
                    formControlName="urgency"
                    placeholder="Select"
                  >
                  </p-select>
                </div>
              </div>
            </div>
          }
          <div class="field">
            <label class="font-interruption">HCPC:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.hcpcCode }}</div>
            </div>
          </div>
          <div class="field">
            <label class="font-interruption">Total Previously Approved Visits: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.totalPreviouslyApprovedVisits }}</div>
            </div>
          </div>
          @if (serviceLineEditForm.get('urgency')?.value && isReviewPeriodDefaultA) {
            <div class="field">
              <label class="font-interruption">Review Period: </label>
              <div class="p-field-value">
                <div class="readonly-field">{{ getReviewPeriodAType() }}</div>
                <p-message severity="info">
                  {{ setInfoTitleMessage() }}
                </p-message>
              </div>
            </div>
          }
          @if (!hideReviewPeriodField && hh30DayReviewPeriods && !isReviewPeriodDefaultA) {
            <div class="field items-baseline" [class.p-disabled]="reviewPeriodTypeControl.disabled">
              <label class="font-interruption">Review Period:</label>
              <div class="p-field space-y-4">
                @for (radio of reviewPeriodOptions; track radio) {
                  <div class="flex items-center">
                    <p-radio-button
                      tabindex="-1"
                      [value]="radio.value"
                      [inputId]="'reviewPeriod_' + radio.value"
                      formControlName="reviewPeriodType"
                    />
                    <label [for]="'reviewPeriod_' + radio.value" class="ml-2">{{ radio.label }}</label>
                  </div>
                }
              </div>
            </div>
          }
          @if (currentEditStep > 0 && showDateDisciplineFirstVisit) {
            <div class="field flex items-center">
              @if (showNA) {
                <label class="font-interruption mb-0">Date of Discipline's First Visit:</label>
              }
              @if (!showNA) {
                <label class="font-interruption mb-0">
                  When will the very last visit, from the previously approved visit(s) be completed?
                </label>
              }
              <div class="flex">
                <div>
                  <p-date-picker
                    appendTo="body"
                    formControlName="dateLastVisitDelivered"
                    tabindex="-1"
                    [readonlyInput]="true"
                    [showTime]="false"
                    [showIcon]="true"
                    (onSelect)="handleDateLastVisitDeliveredSelected()"
                    [minDate]="minDateLastVisitDeliveredDate"
                    [maxDate]="maxDateLastVisitDeliveredDate"
                  >
                  </p-date-picker>
                </div>
                @if (showNA) {
                  <div class="flex py-2">
                    <label class="px-4">OR</label>
                    <div class="flex items-center">
                      <p-checkbox
                        inputId="dateLastVisitNACheck"
                        binary="true"
                        [formControl]="dateLastVisitDeliveredNAControl"
                        (onChange)="handleDateLastVisitNASelected($event)"
                      ></p-checkbox>
                      <label for="dateLastVisitNACheck" class="ml-2">N/A</label>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
          @if (currentEditStep > 1) {
            <div class="field">
              <label class="font-interruption">Retroactive Date Range: </label>
              <div class="p-field-value">
                <div class="readonly-field">{{ editDetail.retroDateRange }}</div>
              </div>
            </div>
          }
          @if (isGettingRetroDateRange) {
            <p-progressSpinner></p-progressSpinner>
          }
          @if (editDetail.retroDateRange !== 'No Retro Period' && currentEditStep > 1 && !retroEffectiveDatePriorToSelectedReviewPeriod) {
            <div class="col p-0">
              <div class="field flex items-center">
                <label class="font-interruption">Retro Visits Requested:</label>
                <div class="flex flex-col">
                  <p-inputNumber
                    formControlName="retroVisitsRequested"
                    class="number-input"
                    buttonLayout="horizontal"
                    inputId="horizontal"
                    spinnerMode="horizontal"
                    decrementButtonClass="p-button-danger"
                    incrementButtonClass="p-button-success"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    mode="decimal"
                    inputNumberUpdateValidation
                    [useGrouping]="false"
                    [showButtons]="true"
                    [min]="0"
                    [step]="1" />
                </div>
              </div>
            </div>
          }
          @if (currentEditStep > 2 && showTimelyAndTotalVisits) {
            <div class="field flex items-center">
              <label class="font-interruption mb-0">Timely Visits Requested:</label>
              @if (isHHRequestProcessUpdates && timelyVisitsRequestedControl.disabled) {
                <div class="p-field-value">
                  <div class="readonly-field">{{ timelyVisitsRequestedControl?.value }}</div>
                </div>
              } @else {
                <div class="p-field">
                  <p-inputNumber
                    formControlName="timelyVisitsRequested"
                    class="number-input"
                    buttonLayout="horizontal"
                    inputId="horizontal"
                    spinnerMode="horizontal"
                    decrementButtonClass="p-button-danger"
                    incrementButtonClass="p-button-success"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                    mode="decimal"
                    inputNumberUpdateValidation
                    [showButtons]="true"
                    [min]="0"
                    [step]="1"
                    (onInput)="checkVisitCountForExternalUser($event)" />
                  <br>
                  @if (timelyVisitsRequestedControl.hasError('max')) {
                    <small class="p-error">
                      Timely Visits Requested must be between 0 and 9999.
                    </small>
                  }
                </div>
              }
            </div>
          }
          @if (isGettingRetroDateRange) {
            <p-progressSpinner></p-progressSpinner>
          }
          @if (currentEditStep > 2 && showTimelyAndTotalVisits) {
            <div class="field">
              <label class="font-interruption">Total Visits Requested:</label>
              <div class="p-field-value">
                <div class="readonly-field">{{ editDetail.totalVisitsRequested }}</div>
              </div>
            </div>
          }
          @if (isCurrentEditSNType) {
            <div class="field flex items-center">
              <label class="flex items-center"><span class="is-required">*</span>Does the Member meet any of the
                following criteria?</label>
            </div>
            <ng-container formArrayName="memberCriteriaIds">
              @for (optionFormGroup of memberCriteriaFormArray.controls; track optionFormGroup; let i = $index) {
                <ng-container [formGroupName]="i">
                  <div class="p-field-checkbox-container">
                    <div class="flex items-center">
                      <p-checkbox
                        inputId="memberCriteria_{{i}}"
                        class="mb-2"
                        formControlName="selected"
                        [binary]="true"
                      ></p-checkbox>
                      <label for="memberCriteria_{{i}}"
                             class="ml-2">{{ optionFormGroup.controls.value.value.label }}</label>
                    </div>
                  </div>
                </ng-container>
              }
            </ng-container>
          }
          @if (isExternalUser) {
            <p-message severity="warn" class="no-gap mt-4" icon="pi pi-exclamation-triangle" [closable]="true">
              <div class="flex flex-row">
                <div class="ml-2">
                  <span><b>Warning.</b></span><br>
                  <div style="margin-top:7px;">Please select Urgent when creating the Authorization or the Service
                    Line to
                    indicate need for expedited review. This box should not be used to indicate expedited need.
                  </div>
                </div>
              </div>
            </p-message>
          }
          @if (isExternalUser) {
            <div class="field flex flex-col">
              <label for="additionalComments" class="font-interruption block">Additional Comments:</label>
              <div class="p-field-value w-full block">
                        <textarea id="additionalComments" pInputTextarea formControlName="additionalComments" rows="4"
                                  [autoResize]="false"
                                  maxlength="500" class="w-full"></textarea>
              </div>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
} @else {
  <div class="service-line-dialog">
    <form [formGroup]="serviceLineEditForm">
      @if (!showHeaderForDateSelect && !hh30DayReviewPeriods) {
        <p-panel class="mb-8" [toggleable]="false" header="Instructions">
          <div class="edit-instructions-panel">{{ editInstructions }}</div>
        </p-panel>
      }
      <div class="flex flex-col p-form-widget p-form-view-data">
        <div class="p-offset-1">
          <div class="field">
            <label>Date/Time Request Received:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.dateTimeFaxRecieved | date :'MM/dd/yyyy hh:mm:ss a' }}</div>
            </div>
          </div>
        </div>
        @if (requestType === initialRequestType) {
          <div class="p-offset-1">
            <div class="field">
              <label>Urgency: </label>
              <div class="p-field-value">
                <div class="readonly-field">{{ editDetail.urgency }}</div>
              </div>
            </div>
          </div>
        }
        <div class="flex items-baseline">
          @if (requestType === subsequentRequestType && currentEditStep === 0) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-arrow-right icon-edit-next"></i>
            </div>
          }
          @if (requestType === subsequentRequestType && currentEditStep > 0) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-check icon-edit-complete"></i>
            </div>
          }
          @if (requestType === subsequentRequestType) {
            <div class="col p-0">
              <div class="field">
                <label>Urgency:</label>
                <div class="p-field-value">
                  <p-select
                    [options]="urgencies"
                    formControlName="urgency"
                    placeholder="Select"
                  >
                  </p-select>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="p-offset-1">
          <div class="field">
            <label>HCPC:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.hcpcCode }}</div>
            </div>
          </div>
        </div>
        <div class="p-offset-1">
          <div class="field">
            <label>Total Previously Approved Visits: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ editDetail.totalPreviouslyApprovedVisits }}</div>
            </div>
          </div>
        </div>
        @if (!hideReviewPeriodField && hh30DayReviewPeriods) {
          <div class="p-offset-1">
            <div class="field" [class.p-disabled]="reviewPeriodTypeControl.disabled">
              <label>Review Period:</label>
              <div class="p-field-value">
                <div class="p-grid">
                  <div class="col-span-12 flex flex-col">
                    @for (radio of reviewPeriodOptions; track radio) {
                      <div class="flex items-center mb-2">
                        <p-radio-button
                          [value]="radio.value"
                          [inputId]="'reviewPeriod_' + radio.value"
                          formControlName="reviewPeriodType"
                        />
                        <label [for]="'reviewPeriod_' + radio.value" class="ml-2">{{ radio.label }}</label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        <div class="flex items-baseline">
          @if (currentEditStep === 1 && hh30DayReviewPeriods ? showDateDisciplineFirstVisit : true) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-arrow-right icon-edit-next"></i>
            </div>
          }
          @if (currentEditStep > 1 && hh30DayReviewPeriods ? showDateDisciplineFirstVisit : true) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-check icon-edit-complete"></i>
            </div>
          }
          @if (currentEditStep > 0 && hh30DayReviewPeriods ? showDateDisciplineFirstVisit : true) {
            <div class="col p-0">
              <div class="field">
                @if (showNA) {
                  <label>Date of Discipline's First Visit:</label>
                }
                <div class="flex font-semibold">
                  @if (!showNA) {
                    <label>When will the very last visit, from the previously approved visit(s) be completed?</label>
                  }
                </div>
                <div class="flex">
                  <div class="p-field-value" [class.mr-2]="!showNA">
                    <p-date-picker
                      appendTo="body"
                      formControlName="dateLastVisitDelivered"
                      tabindex="-1"
                      [readonlyInput]="true"
                      [showTime]="false"
                      [showIcon]="true"
                      (onSelect)="handleDateLastVisitDeliveredSelected()"
                      [minDate]="minDateLastVisitDeliveredDate"
                      [maxDate]="maxDateLastVisitDeliveredDate"
                    >
                    </p-date-picker>
                  </div>
                  @if (showNA) {
                    <div class="py-2">
                      <label class="px-4">OR</label>
                      <div class="flex items-center">
                        <p-checkbox
                          inputId="dateLastVisitNACheck2"
                          binary="true"
                          [formControl]="dateLastVisitDeliveredNAControl"
                          (onChange)="handleDateLastVisitNASelected($event)"
                        ></p-checkbox>
                        <label for="dateLastVisitNACheck2" class="ml-2">N/A</label>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        <div class="flex items-baseline">
          @if (currentEditStep === 2) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-arrow-right icon-edit-next"></i>
            </div>
          }
          @if (currentEditStep > 2) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-check icon-edit-complete"></i>
            </div>
          }
          @if (currentEditStep > 1) {
            <div class="col p-0">
              <div class="field">
                <label>Retroactive Date Range: </label>
                <div class="p-field-value">
                  <div class="readonly-field">{{ editDetail.retroDateRange }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (isGettingRetroDateRange) {
          <p-progressSpinner></p-progressSpinner>
        }
        <div class="flex items-baseline">
          @if (editDetail.retroDateRange !== 'No Retro Period' && currentEditStep === 2) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-arrow-right icon-edit-next"></i>
            </div>
          }
          @if (editDetail.retroDateRange !== 'No Retro Period' && currentEditStep > 2) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-check icon-edit-complete"></i>
            </div>
          }
          @if (editDetail.retroDateRange !== 'No Retro Period' && currentEditStep > 1) {
            <div class="col p-0">
              <div class="field flex items-center">
                <label class="label">Retro Visits Requested:</label>
                <div class="flex flex-col">
                  <p-inputNumber
                    formControlName="retroVisitsRequested"
                    [useGrouping]="false"
                    mode="decimal"
                    [showButtons]="true"
                    [min]="0"
                    inputNumberUpdateValidation
                  ></p-inputNumber>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="flex items-baseline">
          @if (currentEditStep === 3) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-arrow-right icon-edit-next"></i>
            </div>
          }
          @if (currentEditStep > 3) {
            <div class="col-span-1">
              <i aria-hidden="true" class="pi pi-check icon-edit-complete"></i>
            </div>
          }
          @if (currentEditStep > 2 && showTimelyAndTotalVisits) {
            <div class="col p-0">
              <div class="field">
                <label>Timely Visits Requested:</label>
                <div class="p-field-value flex flex-col">
                  <p-inputNumber
                    formControlName="timelyVisitsRequested"
                    [useGrouping]="false"
                    (onInput)="checkVisitCountForExternalUser($event)"
                    mode="decimal"
                    [showButtons]="true"
                    [min]="0"
                    inputNumberUpdateValidation
                  ></p-inputNumber>
                  @if (timelyVisitsRequestedControl.hasError('max')) {
                    <small class="p-error">
                      Timely Visits Required must be between 0 and 9999.
                    </small>
                  }
                </div>
              </div>
            </div>
          }
        </div>
        @if (currentEditStep > 2 && showTimelyAndTotalVisits) {
          <div class="p-offset-1">
            <div class="field">
              <label>Total Visits Requested:</label>
              <div class="p-field-value">
                <div class="readonly-field">{{ editDetail.totalVisitsRequested }}</div>
              </div>
            </div>
          </div>
        }
        @if (isCurrentEditSNType) {
          <div class="p-offset-1 ml-2 mt-2">
            <div class="field flex items-center">
              <label class="flex items-center"><span class="is-required">*</span>Does the Member meet any of the
                following criteria?</label>
            </div>
            <ng-container formArrayName="memberCriteriaIds">
              @for (optionFormGroup of memberCriteriaFormArray.controls; track optionFormGroup; let i = $index) {
                <ng-container [formGroupName]="i">
                  <div class="p-field-checkbox-container">
                    <div class="flex items-center">
                      <p-checkbox
                        inputId="memberCriteria2_{{i}}"
                        formControlName="selected"
                        [binary]="true"
                      ></p-checkbox>
                      <label for="memberCriteria2_{{i}}"
                             class="ml-2">{{ optionFormGroup.controls.value.value.label }}</label>
                    </div>
                  </div>
                </ng-container>
              }
            </ng-container>
          </div>
        }
      </div>
    </form>
  </div>
}

<div class="flex justify-end">
  <button
    type="button"
    pButton
    label="Cancel"
    class="p-button-secondary mr-2"
    (click)="cancel()">
  </button>
  <button
    type="button"
    pButton
    label="Save"
    [disabled]="!serviceLineEditForm.valid || !requestedVisitsValid || isDisabled || !memberCriteriaValid"
    (click)="save()">
  </button>
</div>
